import React, { useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import { validateTextOnlyAlphanumeric, validatorField } from "../../Utils/validators";
import ErrorCustom from "../../Components/errorCustom";
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";

interface Props {
  disableRemove: boolean;
  contributionsData: Array<any>;
  contribution: Object;
  index: number;
  removeContribution: Function;
  count: number;
}

export const FamilyContributionForm = ({
  disableRemove,
  contributionsData,
  contribution,
  index,
  removeContribution,
  count,
}: Props) => {
  const methods = useFormContext();
  const { register, errors, watch, setValue, control } = methods;

  const moneyTypeControl = contributionsData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Moneda");
  const amountControl = contributionsData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Monto");
  const relationshipControl = contributionsData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Parentesco");
  const namesControl = contributionsData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Nombre y apellido");

  const moneyTypeSk = Object.keys(contribution)[0];
  const amountSk = Object.keys(contribution)[1];
  const relationshipSk = Object.keys(contribution)[2];
  const namesSk = Object.keys(contribution)[3];


  const remove = (e: any) => {
    e.preventDefault();
    if(disableRemove) return;
    removeContribution(index);
  };

  const addCommas = (num: any) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <div
        className={`beneficiaryForm${index === 0 ? " first" : ""}`}
        style={{ position: "relative" }}
      >
        <div className="clientForm__beneficiary-box">
          <div className="clientForm__beneficiary-box-icon">
            <IconBeneficiario />
            <div className="clientForm__beneficiary">
              Aporte Familiar {(index+1) + 1}
            </div>
          </div>
          {count > 0 && (
            <p
              className={`clientForm__eliminar ${disableRemove ? "disabled-action" : ""}`}
              onClick={(e) => {
                remove(e);
              }}
            >
              Eliminar
            </p>
          )}
        </div>
      </div>

      {contributionsData[0] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="question__control input-field">
              {moneyTypeControl && (
                <select
                  name={moneyTypeSk}
                  id={moneyTypeSk}
                  ref={register({ validate: validatorField })}
                >
                  <option value={""} disabled selected>
                    {moneyTypeControl.metadata.placeholder}
                  </option>
                  {moneyTypeControl.metadata.options.map((option: any, idx: number) => (
                    <option value={option} key={idx}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              <ErrorCustom errors={errors} name={moneyTypeSk} />
            </div>

            <div className="clientForm__control input-field">
              <Controller
                as={NumberFormat}
                id={amountSk}
                name={amountSk}
                control={control}
                maxLength={amountControl.metadata.maxLength}
                rules={{
                  required: true,
                }}
              />
              <label
                htmlFor={
                  amountSk
                }
              >
                {amountControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={amountSk} />
            </div>
          </div>
        </div>
      )}

      {contributionsData[1] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="question__control input-field">
              <select 
                name={relationshipSk} 
                id={relationshipSk}
                ref={register({ validate: validatorField })}
              >
                <option value={""} disabled selected>
                  {relationshipControl.metadata.placeholder}
                </option>
                {relationshipControl.metadata.options.map((option: any, idx: number) => (
                  <option value={option} key={idx}>
                    {option}
                  </option>
                ))}
              </select>
              <ErrorCustom errors={errors} name={relationshipSk} />
            </div>
            
            <div className="clientForm__control input-field">
              <input 
                id={namesSk} 
                name={namesSk} 
                type="text" 
                autoComplete="off"
                maxLength={namesControl.metadata.maxLength}
                ref={register({ validate: validatorField })}
              />
              <label htmlFor={namesSk}>{namesControl.metadata.placeholder}</label>
              <ErrorCustom errors={errors} name={namesSk} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
